<!-- 修改密码 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ModifyPassword">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 修改密码表单 -->
        <div class="w-300">
          <el-form
            class="demo-ruleForm"
            ref="ruleForm2"
            :model="ruleForm2"
            :rules="rules2"
            status-icon>
            <el-form-item prop="pass">
              <el-input type="password" v-model="ruleForm2.pass" autocomplete="off" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off" placeholder="请再次输入密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm2')">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { loginApi } from "../../../../static/js/api.js"
  import { showToast } from '../../../../static/js/utility/utility';

  export default {
    name: 'ModifyPassword',
    components: {
      BreadCrumb
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if(value.length < 6) {
          callback(new Error('密码不能低于6位'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm2.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        ruleForm2: {
          pass: '',
          checkPass: ''
        },
        rules2: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      };
    },
    mounted(){
    },
    created: function () {
    },
    methods: {
      // 提交表单，确认修改密码
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.changeUserPassword()
          } else {
            showToast('错误的提交!! 请重新提交');
            return false;
          }
        });
      },
      // 修改密码
      changeUserPassword: async function () {
        let data = {
           new_password: this.ruleForm2.pass,
           confirm_new_password: this.ruleForm2.checkPass
        }
        let res = await loginApi.changeUserPassword(data)
        if (res.meta.code === 200) {
          showToast('修改密码成功')
          setTimeout(() => {
            // 退出登录,跳转登录页,重新登录
            localStorage.clear()
            sessionStorage.clear()
            this.$router.push({
              path: '/'
            })
          }, 1000);
        } else {
          showToast(res.meta.message)
        }
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
.w-300 {
  width: 300px;
  padding: 30px 0;
  .el-form {
    .el-form-item  {
        height: 40px;
    }
  }
  .el-input {
    // margin-bottom: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Other/ModifyPassword.vue